import React from "react";
import {
  Box,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  InputLabel,
  Switch,
  Typography,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const SwitchWithLabelHelperText = () => {
  return (
    <>
      <Box p={3}>
        <Typography variant={"h6"} color={"text.primary"}>
          Switch With Label and helperText
        </Typography>
        <Typography variant={"body2"} color={"text.primary"}>
          a Label is added next to the switch. Switch group label and helpertext
          included.
        </Typography>
      </Box>
      <Box sx={{ width: "80%", marginInline: " auto", p: 3 }}>
        <PreviewAndEditor
          title={"Switch With Label and helperText"}
          language={"js"}
          value={
            '           <FormControl component="fieldset" variant="standard">\n' +
            "            <InputLabel>Assign responsibility</InputLabel>\n" +
            "            <FormGroup>\n" +
            "              <FormControlLabel\n" +
            '                control={<Switch defaultChecked color={"primary"} />}\n' +
            '                label="Gilad Gray"\n' +
            "              />\n" +
            "              <FormControlLabel\n" +
            '                control={<Switch color={"primary"} />}\n' +
            '                label="Jason Killian"\n' +
            "              />\n" +
            "            </FormGroup>\n" +
            "            <FormHelperText>Be careful</FormHelperText>\n" +
            "          </FormControl>"
          }
        >
          <FormControl component="fieldset" variant="standard">
            <InputLabel>Assign responsibility</InputLabel>
            <FormGroup>
              <FormControlLabel
                control={<Switch defaultChecked color={"primary"} />}
                label="Gilad Gray"
              />
              <FormControlLabel
                control={<Switch color={"primary"} />}
                label="Jason Killian"
              />
            </FormGroup>
            <FormHelperText>Be careful</FormHelperText>
          </FormControl>
        </PreviewAndEditor>
      </Box>
    </>
  );
};

export default SwitchWithLabelHelperText;
